import { render } from "./CardTwentyTwo.vue?vue&type=template&id=8a8aa60c"
import script from "./CardTwentyTwo.vue?vue&type=script&lang=js"
export * from "./CardTwentyTwo.vue?vue&type=script&lang=js"

import "./CardTwentyTwo.vue?vue&type=style&index=0&id=8a8aa60c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__